import { apiAuth } from './index';

/**
 * Request: {
 *  forSubmit: bool(true: submit cart, false: add from menu)
 *  dayId: int
 *  companyAddressId: int
 *  foodItemIdQuantityList: [{
 *    foodItemId: int
 *    quantity: int
 *  }]
 * }
 */
export const calculateInvoice = async (params) => {
	try {
		const { data } = await apiAuth.post('invoice/submit', params);

		if (data.success) {
			return data;
		}
		throw data;
	} catch (e) {
		throw e.response ? e.response.data : e;
	}
};

/**
 * Response: { }
 */
export const changeInvoiceAddress = async (
	dayId,
	companyAddressId,
	companyAddressFloorId,
) => {
	try {
		const { data } = await apiAuth.put(`/invoice/changeInvoiceAddress`, {
			dayId,
			companyAddressId,
			companyAddressFloorId,
		});
		return data;
	} catch (e) {
		throw e;
	}
};
